export default __webpack_public_path__ + "static/media/PRA_bag_close 1.50bfea45.wav";